module.exports = __webpack_public_path__ + "static/vinay-490f8eaf56920d53cc6b7db99d187d0e.jpeg";